<template>
  <div class="wrap">
    <div class="item" :class='{"item-little":type==="view"&&level ===3}' @click='itemClick' :level='level'>
      <a-icon v-if="data.is_home===1" type="home" class='home'/>
      <i v-else-if='!addCanUse' class='fit'></i>
      <a-icon v-else type="plus-circle" class="plus" @click="childrensAdd"/>
      <div class='text' v-if='!editCanUse'>
        {{data.field_name || data.name}}
      </div>
      <input v-else :id='"x"+data._id' type="text" class='text' v-model='data.name' @focus='savePrev' @blur='blurEdit'>
      <a-tooltip>
        <template slot="title">
          预览
        </template>
        <a-icon type="eye" @click="childrensPreview" v-if='edit && type === "view" && level === 2'/>
      </a-tooltip>
      <a-tooltip>
        <template slot="title">
          {{settingText}}
        </template>
        <a-icon type="setting" class='setting' @click="childrensSetting" v-if='settingCanUse'/>
      </a-tooltip>
      <a-tag class='tag' :color="data.type==='back'?'blue':'orange'" v-if='type==="process"'>
        {{data.type==='back'?'后台':'前台'}}
      </a-tag>
      <a-popconfirm
        :title="popconfirmTitle"
        @confirm="childrensClose"
        okText="确定"
        cancelText="取消"
      >
        <a-icon type="close" class='close' v-if='removeCanUse'/>
      </a-popconfirm>
      <div class="num" v-show="(children && children.length && !data.open) || type === 'process'">
        {{ children && children.length ? children.length : "" }}
      </div>
      <a-icon
        type="caret-down"
        class="foldIcon"
        v-show="children && children.length && data.open"
        @click="childrensChangeOpen"
      />
      <a-icon
        type="caret-right"
        class="foldIcon"
        v-show="children && children.length && !data.open"
        @click="childrensChangeOpen"
      />
      <div class="foldFit" v-show='(!children || !children.length) && type === "process"'></div>
      <div class="settingFit" v-show='(!children || !children.length) && type === "model"'></div>
      <div class='tableSelect' v-if='type==="view"&&level ===2&&data.tableSelectShow' v-click-outside="closeTableSelect">
        <div class="head">
          <div class="text">
            请选择绑定数据表
          </div>
          <a-icon type='close' @click='closeTableSelect'></a-icon>
        </div>
        <div class="select">
          <div class="item" v-for='(item,index) in model' :key="index">
            <div class="text">
              {{item.name}}
            </div>
            <div class="btn" @click='bindTable(item)'>
              绑定
            </div>
          </div>
        </div>
      </div>
      <div class='tableSelect viewselect' v-if='type==="process"&&data.pageSelectShow' v-click-outside="closePageSelect">
        <div class="head">
          <div class="text">
            请选择绑定页面
          </div>
          <a-icon type='close' @click='closePageSelect'></a-icon>
        </div>
        <div class="select">
          <div class="item" v-for='(item,index) in views' :key="index">
            <div class="text">
              {{item.name}}
            </div>
            <div class="btn" @click='bindView(item)'>
              绑定
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="items" v-if="children && children.length && data.open">
      <item v-for="(item,index) in children" :key="index" :data='item' :type='type' :edit='edit' :level='level+1' :list='children' :levelOne='levelOne' :model='model' :idx='index' :view='view'></item>
    </div>
  </div>
</template>

<script>
import item from './item.vue'
import vClickOutside from 'v-click-outside'

export default {
  name: 'item',
  components: {
    item
  },
  props: {
    data: {
      type: Object
    },
    type: {
      type: String
    },
    edit: {
      type: Boolean
    },
    level: {
      type: Number
    },
    list: {
      type: Array
    },
    levelOne: {
      type: Object
    },
    model: {
      type: Array
    },
    idx: {
      type: Number
    },
    view: {
      type: Array
    }
  },
  data () {
    return {
      prev: ''
    }
  },
  computed: {
    children () {
      return this.data.children || this.data.fields || this.data.components || this.data.events
    },
    popconfirmTitle () {
      switch (this.type) {
        case 'model':
          if (this.level === 1) {
            return '点击确定删除此数据表'
          } else {
            return '点击确定删除此字段'
          }
        case 'view':
          if (this.level === 2) {
            return '点击确定删除此页面'
          } else if (this.level === 4) {
            return '点击确定删除此控件'
          } else if (this.level === 5) {
            return '点击确定删除此事件'
          } else {
            return '点击确定删除此流程'
          }
        case 'process':
          if (this.data.children && this.data.children.length) {
            return '点击确定删除此流程及其子流程'
          } else {
            return '点击确定删除此流程'
          }
        default:
          return '确认删除'
      }
    },
    settingText () {
      switch (this.type) {
        case 'model':
          if (this.level === 1) {
            return '数据表管理'
          } else {
            return '字段设置'
          }
        case 'view':
          if (this.level === 2) {
            return '页面编辑'
          } else if (this.level === 4) {
            return '控件设置'
          } else if (this.level === 5) {
            return '事件设置'
          } else {
            return '流程设置'
          }
        case 'process':
          return '流程逻辑图'
        default:
          return '设置'
      }
    },
    addCanUse () {
      if (!this.edit || (this.type === 'model' && this.level === 2) || (this.type === 'view' && this.level === 2) || (this.type === 'view' && this.level === 3) || (this.type === 'view' && this.level === 4) || (this.type === 'view' && this.level === 5) || (this.type === 'view' && this.level === 6)) {
        // 判断什么情况下不可用
        return false
      }
      return true
    },
    editCanUse () {
      if (!this.edit || this.type === 'model' || (this.type === 'view' && this.level === 1) || (this.type === 'view' && this.level === 3) || (this.type === 'view' && this.level === 4) || (this.type === 'view' && this.level === 5) || (this.type === 'view' && this.level === 6)) {
        return false
      } else {
        return true
      }
    },
    settingCanUse () {
      if (!this.edit || (this.type === 'view' && this.level === 1) || (this.type === 'view' && this.level === 3) || (this.type === 'view' && this.level === 5)) {
        return false
      }
      return true
    },
    removeCanUse () {
      if (!this.edit || this.type === 'model' || (this.type === 'view' && this.level === 1) || (this.type === 'view' && this.level === 3) || (this.type === 'view' && this.level === 4) || (this.type === 'view' && this.level === 5) || (this.type === 'view' && this.level === 6)) {
        return false
      }
      return true
    },
    views () {
      let arr = []
      if (this.view && this.view.length) {
        this.view.map(item => {
          arr = arr.concat(item.children)
        })
      }
      return arr
    }
  },
  methods: {
    childrensAdd () {
      this.$event.$emit('childrensAdd', this.data, this.type, this.level, this.levelOne)
    },
    childrensPreview () {
      this.$event.$emit('childrensPreview', this.data, this.type, this.level)
    },
    childrensSetting () {
      this.$event.$emit('childrensSetting', this.data, this.type, this.level, this.levelOne)
    },
    childrensClose () {
      this.$event.$emit('childrensClose', this.data, this.type, this.level, this.list)
    },
    childrensChangeOpen () {
      this.$event.$emit('childrensChangeOpen', this.data, this.data.open)
    },
    savePrev () {
      this.prev = this.data.name
    },
    blurEdit () {
      if (!this.data.name) {
        this.data.name = this.prev
        this.$message.warn('名称不能为空')
      }
      if (this.prev !== this.data.name) {
        this.$event.$emit('childrensChangeName', this.data, this.type, this.level)
      }
    },
    itemClick (event) {
      if (event.shiftKey) {
        this.childrensChangeOpen()
        return false
      }
    },
    closeTableSelect () {
      this.$set(this.data, 'tableSelectShow', false)
    },
    bindTable (item) {
      this.closeTableSelect()
      this.$event.$emit('pageBindTable', this.list, this.idx, item)
    },
    closePageSelect () {
      this.$set(this.data, 'pageSelectShow', false)
    },
    bindView (item) {
      this.closePageSelect()
      this.$event.$emit('processBindPage', this.data, item)
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  }
}
</script>

<style lang="less">
.wrap {
  &::after{
    display: block;
    clear: both;
    content: '';
  }
  .item {
    width: 260px;
    height: 32px;
    line-height: 32px;
    margin: 4px;
    background: #fff;
    border-radius: 4px;
    display: flex;
    float: left;
    position: relative;
    i {
      cursor: pointer;
      flex-shrink: 0;
      margin: auto 8px auto 0;
      visibility: hidden;
    }
    .plus {
      margin-left: 8px;
      &:hover {
        color: #fc8830;
      }
    }
    .text {
      flex-grow: 1;
      border: none;
      outline: none;
      width: 1px;
    }
    .num {
      margin-right: 8px;
      width: 20px;
      text-align: center;
    }
    .foldIcon {
      margin-right: 16px;
      visibility: visible;
    }
    .foldFit{
      width: 28px;
    }
    .home {
      margin-left: 8px;
      visibility: visible;
      color: #fa883d;
    }
    .fit{
      width: 20px;
    }
    .tag{
      display: block;
      margin: 5px 8px 0 0;
    }
    .setting {
      display: none;
    }
    .settingFit{
      width: 12px;
    }
    .close {
      display: none;
    }
    &:hover {
      i {
        visibility: visible;
      }
      .setting {
        display: block;
      }
      .close {
        display: block;
    }
      .tag{
        display: none;
      }
    }
  }
  .item-little{
    width: 156px;
  }
  .items{
    float: left;
  }
  .tableSelect{
    position: absolute;
    top: 36px;
    width: 240px;
    margin-left: 10px;
    background: #fff;
    border-radius: 4px;
    color: rgba(0,0,0,.65);
    z-index: 1;
    .head,.item{
      padding: 4px 16px;
      line-height: 24px;
      position: relative;
      margin: 0;
      width: 100%;
      i{
        display: block;
        visibility: visible;
        position: absolute;
        right: 0;
      }
    }
    .head{
      border-bottom: 1px solid rgba(0,0,0,0.1);
      padding: 8px 16px;
    }
    .select{
      max-height: 120px;
      overflow-y: auto;
    }
    .item{
      &:hover{
        background: #F5F5F5;
      }
      .btn{
        cursor: pointer;
        &:hover{
          color: #FA883D;
        }
      }
    }
  }
}
</style>
